const AccordionItem = ({ title, children }) => (
    <article className="message">
        <div className="message-header">
            <p>{title}</p>
        </div>
        <div className="message-body">
            {children}
        </div>
    </article>
);

const Accordion = ({ children }) => (
    <div >
        {children}
    </div>
);

export { Accordion, AccordionItem };
